export default "__VITE_ASSET__DzuD8Wqr__"